var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compliance-assets-container"},[_c('div',{staticClass:"compliance-assets-text"},[_vm._v(" "+_vm._s(_vm.getAssets)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }